<template>
  <!-- <v-container> -->
  <v-form ref="form" v-model="valid">
    <v-layout align-center justify-space-around row fill-height wrap>
      <v-flex xs6 md4>
        <v-text-field
          v-model.lazy="email"
          :rules="emailRules"
          label="*E-mail"
          prepend-icon="email"
          name="email"
          type="email"
          @keyup.enter="findLead()"
          autofocus
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs4 md4>
        <v-text-field
          v-model.lazy="cpf"
          label="CPF"
          prepend-icon="assignment_ind"
          name="cpf"
          type="text"
          @keyup.enter="findLead()"
          autofocus
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs1 md2 class="hidden-sm-and-up">
        <v-btn
          :loading="loading"
          :disabled="!valid || loading"
          @click.prevent="findLead()"
          flat
          icon
          color="primary"
        >
          <v-icon> search </v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs1 md2 class="hidden-sm-and-up">
        <v-btn
          class="mx-0 font-weight-light"
          color="info"
          :disabled="loading"
          @click.prevent="openMyDialog"
          flat
          icon
        >
          <v-icon> person_add_alt_1 </v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 md2 class="hidden-sm-and-down">
        <v-spacer></v-spacer>
        <v-btn
          class="mx-0 font-weight-light"
          color="primary"
          :loading="loading"
          :disabled="!valid || loading"
          @click.prevent="findLead()"
          flat
          icon
        >
          <v-icon> search </v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs6 md2 class="hidden-sm-and-down">
        <v-btn
          class="mx-0 font-weight-light"
          color="info"
          :disabled="loading"
          @click.prevent="openMyDialog"
          icon
          fab
        >
          <!-- Novo Cliente -->
          <v-icon> person_add_alt_1 </v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- <cpnCreateCustomer/> -->
  </v-form>
  <!-- </v-container> -->
</template>
<script>
import { getUserByEmail, getUserByCPF } from "../../services/users";
import { getConsumerUnitByUser } from "../../services/consumer_units";
import { getLead } from "../../services/leads";
import { eventBus } from "../../main";
// import CreateCustomer from './CreateCustomer'

export default {
  data: function () {
    return {
      email: "",
      cpf: "",
      emailRules: [
        // v => !!v || "Por favor, informe o email",
        // v => /.+@.+/.test(v) || "E-mail precisa ser válido"
      ],
      loading: false,
      valid: false,
    };
  },
  // components: {
  //     cpnCreateCustomer: CreateCustomer
  // },
  methods: {
    openMyDialog() {
      // eventBus.$off('Lead')
      eventBus.$emit("Lead", {}); // emit the event to the bus
      eventBus.$emit("dialog", true); // emit the event to the bus
    },
    async findLead() {
      this.loading = true;
      if (this.email.trim() === "" && this.cpf.trim() === "") {
        // this.valid = false
        this.loading = false;
        return;
      }
      // eventBus.$off('Lead')
      // console.log('email: ', email)
      // Verifica se tem usuário, se tiver retorna dados
      // Se não possuir, busca lead
      if (this.email !== "") {
        await getLead(this.email)
          .then(async (lead) => {
            // const customer_id = lead.data().customer_id
            await getUserByEmail(this.email)
              .then(async (users) => {
                // console.log('possui user: ', users.docs.length)
                if (users.docs.length > 0) {
                  // console.log('possui user')
                  const user = users.docs[0].data();
                  await getConsumerUnitByUser(user.customer_id)
                    .then((ucs) => {
                      if (ucs.docs.length > 0) {
                        // console.log('possui uc')
                        const uc = ucs.docs[0].data();
                        const newLead = {
                          // data: {
                          ...lead.data(),
                          user: user,
                          consumer_unit: uc,
                          // }
                        };
                        // console.log('lead: ', newLead)
                        eventBus.$emit("Lead", newLead);
                        this.loading = false;
                      } else {
                        const newLead = {
                          // data: {
                          ...lead.data(),
                          user: user,
                          // }
                        };
                        // console.log('lead1: ', newLead)
                        eventBus.$emit("Lead", newLead);
                        this.loading = false;
                      }
                    })
                    .catch((error) => {
                      // console.log('lead2: ', lead.data())
                      console.error("Erro ao pegar usuário: ", error);
                      eventBus.$emit("Lead", lead.data());
                      this.loading = false;
                    });
                } else {
                  // const newLead = {
                  //     exists: lead.exists,
                  //     id: lead.id,
                  //     data: {
                  //         ...lead.data()
                  //     }
                  // }
                  // console.log('lead3: ', lead.data())
                  eventBus.$emit("Lead", lead.data());
                  this.loading = false;
                }
              })
              .catch((error) => {
                // console.log('lead4: ', lead.data())
                console.error("Erro ao pegar usuário: ", error);
                eventBus.$emit("Lead", lead.data());
                this.loading = false;
              });
          })
          .catch((error) => {
            console.error(
              "Lead não encontrado para o email ",
              this.email,
              " + ",
              error,
            );
            this.loading = false;
          });
      } else if (this.cpf.trim() !== "") {
        this.cpf = this.cpf.replace(/[^0-9]+/g, "");
        await getUserByCPF(this.cpf)
          .then(async (users) => {
            // console.log('possui user: ', users.docs.length)
            if (users.docs.length > 0) {
              // console.log('possui user')
              const user = users.docs[0].data();
              const lead = await getLead(user.email);
              // console.log('u: ', user)
              await getConsumerUnitByUser(user.customer_id)
                .then(async (ucs) => {
                  if (ucs.docs.length > 0) {
                    // console.log('possui uc')
                    const uc = ucs.docs[0].data();
                    const newLead = {
                      // data: {
                      ...lead.data(),
                      user: user,
                      consumer_unit: uc,
                      // }
                    };
                    // console.log('lead: ', newLead)
                    eventBus.$emit("Lead", newLead);
                    this.loading = false;
                  } else {
                    const newLead = {
                      // data: {
                      ...lead.data(),
                      user: user,
                      // }
                    };
                    // console.log('lead1: ', newLead)
                    eventBus.$emit("Lead", newLead);
                    this.loading = false;
                  }
                })
                .catch((error) => {
                  // console.log('lead2: ', lead.data())
                  console.error("Erro ao pegar usuário: ", error);
                  eventBus.$emit("Lead", lead.data());
                  this.loading = false;
                });
            } else {
              // const newLead = {
              //     exists: lead.exists,
              //     id: lead.id,
              //     data: {
              //         ...lead.data()
              //     }
              // }
              // console.log('lead3: ', {})
              eventBus.$emit("Lead", {});
              this.loading = false;
            }
          })
          .catch((error) => {
            // console.log('lead4: ', lead.data())
            console.error("Erro ao pegar usuário: ", error);
            eventBus.$emit("Lead", {});
            this.loading = false;
          });
      }
    },
  },
};
</script>
